import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  fetchUserProfile,
  fetchUserDashboard,
  updateUserProfile,
  uploadUserAvatar,
} from "../../store/userSlice";

const UserProfile = () => {
  const dispatch = useDispatch();
  const { profile, status } = useSelector((state) => state.user);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    age: "",
    currentLocation: "",
    phoneNumber: "",
    website: "",
    currentJobPlace: "",
    designation: "",
    qualification: "",
    language: "",
    description: "",
  });
  const [avatarFile, setAvatarFile] = useState(null);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (!profile) return;
    setForm({
      firstName: profile.firstName || "",
      lastName: profile.lastName || "",
      age: profile.age || "",
      currentLocation: profile.currentLocation || "",
      phoneNumber: profile.phoneNumber || "",
      website: profile.website || "",
      currentJobPlace: profile.currentJobPlace || "",
      designation: profile.designation || "",
      qualification: profile.qualification || "",
      language: profile.language || "",
      description: profile.description || "",
    });
  }, [profile]);

  const fullName = useMemo(
    () => `${profile?.firstName || ""} ${profile?.lastName || ""}`.trim(),
    [profile]
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (avatarFile) {
        await dispatch(uploadUserAvatar(avatarFile)).unwrap();
      }
      const { avatar, ...safeProfilePayload } = form;
      void avatar;
      await dispatch(updateUserProfile(safeProfilePayload)).unwrap();
      dispatch(fetchUserDashboard());
      setAvatarFile(null);
      toast.success("Profile updated successfully");
    } catch (err) {
      toast.error(typeof err === "string" ? err : "Failed to update profile");
    }
  };

  return (
    <div className="my-profile-inner">
      <div className="form-wrapper mb-4">
        <div className="section-title">
          <h5>My Profile</h5>
          <p>{fullName || profile?.email || ""}</p>
        </div>
        <form className="profile-form" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>First Name</label>
                <input name="firstName" value={form.firstName} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Last Name</label>
                <input name="lastName" value={form.lastName} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Age</label>
                <input name="age" value={form.age} onChange={handleChange} type="number" />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Profile Image</label>
                <input
                  type="file"
                  accept="image/png,image/jpeg,image/jpg"
                  onChange={(e) => setAvatarFile(e.target.files?.[0] || null)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Current Location</label>
                <input name="currentLocation" value={form.currentLocation} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Phone Number</label>
                <input name="phoneNumber" value={form.phoneNumber} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Email</label>
                <input value={profile?.email || ""} disabled />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Website</label>
                <input name="website" value={form.website} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Current Job Place</label>
                <input name="currentJobPlace" value={form.currentJobPlace} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Designation</label>
                <input name="designation" value={form.designation} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Qualification</label>
                <input name="qualification" value={form.qualification} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-inner mb-25">
                <label>Language</label>
                <input name="language" value={form.language} onChange={handleChange} />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-inner mb-25">
                <label>Description</label>
                <textarea
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-inner">
                <button className="primry-btn-2 lg-btn w-unset" type="submit">
                  {status === "loading" ? "Saving..." : "Update Profile"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UserProfile;
